<template>
  <div class="row justify-content-center p-2">
    <div class="col-xxl-3 text-center col-xl-4 col-lg-6 col-md-6 col-10 pt-2">
      <img alt="Makbill Logo" src="/images/makbilllogo.png" class="img-fluid" />
    </div>
  </div>
  <div class="row mx-0 pt-5 justify-content-center">
    <div class="col-xl-5 col-md-8 col-sm-12 col-10">
      <div class="card">
        <div class="card-header otp-header">Enter Aadhar Otp</div>
        <div class="card-body">
          <form class="d-grid" @submit.prevent="otpSubmit">
            <div class="row justify-content-center p-2">
              <llp-otp-input
                id="otp"
                v-model:modelValue="credential.otp"
                maxlength="6"
                :errors="validator.credential.otp.$error"
              >
              </llp-otp-input>
            </div>
            <div class="row justify-content-center p-2">
              <p v-if="errorMessage" class="text-danger otp-error">
                {{ errorMessage }}
              </p>
            </div>
            <div class="row justify-content-center p-2">
              <div class="col-auto">
                <llp-button
                  :loadSpinner="showLoginSpinner"
                  classNames="btn-secondary text-white new-btn"
                  type="submit"
                >
                  Submit
                </llp-button>
              </div>
            </div>
            <div class="row text-center p-2">
              <p>
                <a
                  class="fw-bold"
                  @click="resendOtp"
                  :class="{ 'text-muted': isResendDisabled }"
                  :disabled="isResendDisabled"
                >
                  Resend OTP
                  <span v-if="remainingTime > 0">({{ formattedTime }})</span>
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { helpers, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
// import NetworkService from '../../services/network.service.js';
import axios from "axios";

export default {
  name: "OtpPage",
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      credential: {
        otp: "",
      },
      ref_id: localStorage.getItem("Ref_id"),
      id: this.$route.query.id,
      token: this.$route.query.token,
      showLoginSpinner: false,
      userId: this.$route.state?.userId,
      errorMessage: null,
      timer: null,
      remainingTime: 0,
      isResendDisabled: false,
      otpExpired: false,
      props: ["refId"],
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.remainingTime / 60);
      const seconds = this.remainingTime % 60;
      return `${minutes}m ${seconds}s`;
    },
  },
  validations() {
    return {
      credential: {
        otp: { required: helpers.withMessage("Otp is required", required) },
      },
    };
  },
  mounted() {
    this.userId = this.$route.params.userId;
     this.remainingTime = 300; 
      this.isResendDisabled = true;
    this.startTimer();
  },
  methods: {
    //       async otpSubmit() {
    //     if (this.otpExpired) {
    //         this.errorMessage = "OTP has expired, Please try again.";
    //         return;
    //     }
    //     this.showLoginSpinner = true;
    //     try {
    //         const data = { otp: this.credential.otp, ref_id: this.ref_id };
    //         const response = await axios.post(`https://efarmers.live/makbill/public/api/aadhar-otp-verification/${this.id}/${this.token}`, data);
    //         console.log("line 117", response);

    //         if (response.data && response.data.status === 'success') {
    //             console.log("otp page redirect to dashboard page");
    //             this.$refs.toast.show(response.data.message);
    //             setTimeout(() => {
    //                 this.$router.push({ name: 'document-verification', query: { id: this.id, token: this.token } });
    //             }, 2000);
    //         }
    //     } catch (error) {
    //         this.showLoginSpinner = false;
    //         this.errorMessage = error.message;
    //     } finally {
    //         this.showLoginSpinner = false;
    //     }
    // },

    //         async resendOtp() {
    //             if (this.isResendDisabled) return;
    //              this.errorMessage = '';
    //             this.credential.otp='';
    //              this.otpExpired = false;
    //             this.isResendDisabled = true;
    //             // this.remainingTime = 300;
    //          this.remainingTime = 60;
    //             const resendresponse = await axios.post(`https://efarmers.live/makbill/public/api/aadhar-resend-otp/${this.id}/${this.token}`);
    //             console.log("response", resendresponse);
    //             // Start countdown timer
    //             this.timer = setInterval(() => {
    //                 if (this.remainingTime > 0) {
    //                     this.remainingTime--;
    //                 } else {
    //                     clearInterval(this.timer);
    //                     this.isResendDisabled = false;
    //                     this.otpExpired = true;
    //                 }
    //             }, 1000);
    //         }

     startTimer() {
      // Clear previous timer if any
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.isResendDisabled = false;
          this.otpExpired = true;
        }
      }, 1000);
    },
    async otpSubmit() {
        if (!this.credential.otp) {
        this.errorMessage = "Otp is required";
        return;
      }
      if (this.otpExpired) {
        this.errorMessage = "OTP has expired, Please try again.";
        return;
      }
      this.showLoginSpinner = true;
      try {
        const data = { otp: this.credential.otp, ref_id: this.ref_id };
        // const response = await axios.post(`https://efarmers.live/makbill/public/api/aadhar-otp-verification/${this.id}/${this.token}`, data);
        const response = await axios.post(
          `https://connect.makbill.com/api/aadhar-otp-verification/${this.id}/${this.token}`,
          data
        );

        if (response.data && response.data.status === "success") {
          this.$refs.toast.show(response.data.message);
          setTimeout(() => {
            this.$router.push({
              name: "document-verification",
              query: { id: this.id, token: this.token },
            });
          }, 2000);
        } else if (response.data && response.data.message) {
          // Handle API-specific error messages
          this.errorMessage = response.data.message;
        }
      } catch (error) {
        this.showLoginSpinner = false;
        if (error.response) {
          // The request was made and the server responded with a status code
          if (error.response.status === 400) {
            this.errorMessage =
              error.response.data.message ||
              "Invalid OTP. Please check and try again.";
          } else {
            this.errorMessage = "Something went wrong. Please try again later.";
          }
        } else if (error.request) {
          // The request was made but no response was received
          this.errorMessage = "Network error. Please check your connection.";
        } else {
          // Something happened in setting up the request
          this.errorMessage = "An unexpected error occurred.";
        }
      } finally {
        this.showLoginSpinner = false;
      }
    },

    async resendOtp() {
      if (this.isResendDisabled) return;
      this.errorMessage = "";
      this.credential.otp = "";
      this.otpExpired = false;
      this.isResendDisabled = true;
      this.remainingTime = 300;
       this.startTimer();

      try {
        const resendresponse = await axios.post(
          `https://connect.makbill.com/api/aadhar-resend-otp/${this.id}/${this.token}`
        );

        if (resendresponse.data && resendresponse.data.message) {
          this.$refs.toast.show(resendresponse.data.message);
        }

        // Start countdown timer
        this.timer = setInterval(() => {
          if (this.remainingTime > 0) {
            this.remainingTime--;
          } else {
            clearInterval(this.timer);
            this.isResendDisabled = false;
            this.otpExpired = true;
          }
        }, 1000);
      } catch (error) {
        if (error.response) {
          if (error.response.status === 400) {
            this.errorMessage =
              error.response.data.message ||
              "Failed to resend OTP. Please try again.";
          } else {
            this.errorMessage = "Something went wrong. Please try again later.";
          }
        } else if (error.request) {
          this.errorMessage = "Network error. Please check your connection.";
        } else {
          this.errorMessage = "An unexpected error occurred.";
        }
        this.isResendDisabled = false;
      }
    },
  },
};
</script>

<style scoped>
a.text-muted {
  pointer-events: none;
  color: #3d3892 !important;
}
</style>
